import React__default from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Tippy from '@tippy.js/react';
import { c as commonPropTypes } from './commonPropTypes-c0ea5832.js';
import { T as TooltipThemes } from './types-cb7b719f.js';

var styles = {"tooltip":"Tooltip-module_tooltip__3x8S8","tooltip--light-mode":"Tooltip-module_tooltip--light-mode__2zfRc","tooltip--default":"Tooltip-module_tooltip--default__1j_aW","tooltip--bordered":"Tooltip-module_tooltip--bordered__hlQkL","tooltip--dark-mode":"Tooltip-module_tooltip--dark-mode__A5uFi","tooltip--warning-mode":"Tooltip-module_tooltip--warning-mode__3oyyq"};

const MAX_WIDTH_FALLBACK = 288;
const DEFAULT_TOOLTIP_Z_INDEX = 2500;

// legacy conversion
const whitelist = {
  bottom: 'bottom',
  center: 'top',
  left: 'left',
  right: 'right',
  top: 'top',
  topLeft: 'top-start',
  topRight: 'top-end'
};
const whitelistPlacement = placement => whitelist[placement] || 'top';
const renderChildren = children => {
  const child = Array.isArray(children) ? children[0] : children;

  // for components you don't have access to set ref, wrap in <span>
  // @ref https://github.com/atomiks/tippy.js-react/issues/49#issuecomment-470198792
  if (typeof child.type === 'function') {
    return /*#__PURE__*/React__default.createElement("span", null, child);
  }
  return child;
};

/**
 * Tooltip component renders tooltip with content.
 *
 */

const Tooltip = ({
  appendTo = null,
  arrow = true,
  bordered = false,
  boundary = 'window',
  children = null,
  className,
  flipBehavior = 'flip',
  flipOnUpdate = false,
  interactive = false,
  maxWidth = MAX_WIDTH_FALLBACK,
  overlay = null,
  placement = 'top',
  tooltipTheme = TooltipThemes.DARK,
  visible,
  zIndex = DEFAULT_TOOLTIP_Z_INDEX
}) => {
  // "appendTo" defaults to "parent" instead of "document.body" if "interactive: true"
  // need to explicitly set "document.body"
  if (!appendTo && typeof window !== 'undefined') {
    appendTo = document.body;
  }
  return /*#__PURE__*/React__default.createElement(Tippy, {
    flip: true,
    animation: "fade",
    appendTo: appendTo,
    arrow: arrow,
    boundary: boundary,
    className: cx(styles.tooltip, styles[`tooltip--${tooltipTheme}-mode`], {
      [styles['tooltip--bordered']]: bordered,
      [styles['tooltip--default']]: !bordered
    }, className),
    content: overlay,
    distance: 16,
    flipBehavior: flipBehavior,
    flipOnUpdate: flipOnUpdate,
    hideOnClick: false,
    interactive: interactive,
    maxWidth: maxWidth,
    placement: whitelistPlacement(placement),
    theme: tooltipTheme,
    visible: visible,
    zIndex: zIndex
  }, renderChildren(children));
};
Tooltip.propTypes = {
  /**
    * Element to which tooltip will be append
  */
  appendTo: commonPropTypes.children,
  arrow: PropTypes.bool,
  /**
    * Activate bordered style of tooltip
  */
  bordered: PropTypes.bool,
  boundary: PropTypes.string,
  /**
     * Tooltip anchor element - anything that can be rendered: numbers, strings, elements or an array
    */
  children: commonPropTypes.children.isRequired,
  /**
    * Adds class to root container
  */
  className: commonPropTypes.className,
  /**
    * Show or hide arrows
  */
  flipBehavior: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
  flipOnUpdate: PropTypes.bool,
  interactive: PropTypes.bool,
  /**
    * Maximum width of tooltip
  */
  maxWidth: PropTypes.number,
  /**
   * Anything that can be rendered inside tooltip: numbers, strings, elements or an array
  */
  overlay: commonPropTypes.children,
  /**
    * Placement of tooltip like top, left...
  */
  placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left', 'topLeft', 'topRight']),
  /**
   * component theme - light or dark
  */
  tooltipTheme: PropTypes.oneOf(Object.values(TooltipThemes)),
  /**
    * Show or hide tooltip, if not specify, tooltip shows on hover
  */
  visible: PropTypes.bool,
  /**
    * zIndex of tooltip
  */
  zIndex: PropTypes.number
};
var Tooltip$1 = Tooltip;

export { DEFAULT_TOOLTIP_Z_INDEX as D, Tooltip$1 as T };
